<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">Technician Team/Department Change List</div>
                    <div class="pagebutton">
                        <router-link class="themebutton" title="Add Technician Team/Department Change" v-bind:to="{name: 'AddUpdateTechnicianTeamDepartmentChanges'}">
                            <span>Add Technician Team/Department Change</span>
                        </router-link>
                        <a class="themebutton" style="margin-right: 5px; color: white;" id='exportAllTechTimeId' title='Export' v-on:click.prevent="exportTechTeamDepartmentChangeFunction(1)">
                            <span>Export</span>
                        </a>
                        <a class="themebutton" style="margin-right: 5px; color: white;" id='' :title='listName' v-on:click.prevent="loadArchivedRequestList()">
                            <span>{{listName}}</span>
                        </a>
                    </div>
                </div>
                <div class="clearfix"></div>
                <vue-good-table
                    ref="TechTeamDepartmentChangeList"
                    mode="remote"
                    title="Technician Team/Department Change Form List"
                    @on-page-change="onPageChange"
                    @on-selected-rows-change="selectionChanged"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :selectOptions="{
                        enabled: true,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                    }"
                    :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: serverParams.perPage,
                        setCurrentPage: serverParams.setCurrentPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                    }"
                    :search-options="{
                        enabled: false,
                    }">
                    <!-- Custome Pagination -->
                    <template slot="pagination-bottom" slot-scope="props">
                        <div class="vgt-wrap__footer crm">
                            <div  class="row">
                                <div class="col-sm-12 col-md-2 PerPage">
                                    <v-select title="Select Per Page"
                                        class="pagination-select-box"
                                        v-model="serverParams.perPage"
                                        @change="changedValueTask"
                                        @input="changedValueTaskCustomPerPageTask()"
                                        name="customPerPage"
                                        id="customPerPage"
                                        label="text"
                                        :clearable="false"
                                        :searchable="false"
                                        :filterable="false"
                                        :options="serverParams.perPageDropdown"
                                        placeholder="Select Per Page">
                                    </v-select>
                                </div>
                                <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                    <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                </div>
                                <div class="col-sm-12 col-md-6 Pagination">
                                    <ul class="pagination">
                                        <li class="FirstPage" title="First Page">
                                            <template v-if="Number(serverParams.page) == 1">
                                                <a class="page-link" href="javascript:void(0)">1</a>
                                            </template>
                                            <template v-else>
                                                <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                            </template>
                                        </li>
                                        <li class="page-item PreviousPage" title="Previous Page">
                                            <template v-if="Number(serverParams.page) == 1">
                                                <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                            </template>
                                            <template v-else>
                                                <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                            </template>
                                        </li>
                                        <!--New Implementation-->
                                        <template v-if="pageNumberListTask() < displayPageTask">
                                            <template v-for="(n, index) in pageNumberListTask()">
                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                    <a class="page-link" href="javascript:void(0)">
                                                        {{n}}
                                                    </a>
                                                </li>
                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                    <a class="page-link" href="javascript:void(0)">
                                                        {{n}}
                                                    </a>
                                                </li>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <!--End New Implementation-->
                                            <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                <template v-for="(n, index) in displayPageTask">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                            <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                <template v-for="(n, index) in pageNumberListTask()">
                                                    <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                        </template>
                                        <li class="page-item NextPage" title="Next Page">
                                            <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                            </template>
                                            <template v-else>
                                                <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                            </template>
                                        </li>
                                        <li class="LastPage" title="Last Page">
                                            <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                            </template>
                                            <template v-else>
                                                <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                            </template>
                                        </li>
                                    </ul>
                                </div>
                                <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                    <p class="pageJumpLabel">Page : </p>
                                </div>
                                <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                    <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                </div>
                            </div>
                        </div>
                    </template>
                    <!-- End Custome Pagination -->
                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                            <div v-if="props.column.field == 'action'" class="table-action">
                                <router-link v-if="user_role == 1" title='Edit Technician Team/Department Change' class="btn edit-btn-vvg waves-effect pull-left" v-bind:to="{name: 'UpdateTechnicianTeamDepartmentChanges', params:{id: props.row.id}}">
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </router-link>
                                <template v-if="!props.row.is_archive">
                                    <a href="javascript:void(0)" @click="archivedUnArchivedRequest(props.row.id, 1, 'Archive')" title='Archive' class="btn edit-btn-vvg waves-effect pull-left">
                                        <i class="fa fa-archive" aria-hidden="true"></i>
                                    </a>
                                </template>
                                <template v-else>
                                    <a href="javascript:void(0)" @click="archivedUnArchivedRequest(props.row.id, 0, 'Unarchive')" title='Unarchive' class="btn edit-btn-vvg waves-effect pull-left">
                                        <i class="fa fa-archive" aria-hidden="true"></i>
                                    </a>
                                </template>
                            </div>
                            <div v-else>
                                {{props.formattedRow[props.column.field]}}
                            </div>
                        </div>
                    </template>
                    <div slot="selected-row-actions" slot-scope="computed">
                        {{computed.selectedRows}}
                        <button id="exportTechTeamDepartmentChangeId" v-on:click.prevent="exportTechTeamDepartmentChangeFunction(0)" class="btn btn-success" title="Export">
                            Export {{selectedRows}} Record(s)
                        </button>
                        <template v-if="listName == 'Archived List'">
                            <button id="" v-on:click.prevent="archivedUnArchivedRequest(0, 1, 'Archive')" class="btn btn-success" title="Archive">
                                Archived {{ selectedRows }} Record(s)
                            </button>
                        </template>
                        <template v-else>
                            <button id="" v-on:click.prevent="archivedUnArchivedRequest(0, 0, 'Unarchive')" class="btn btn-success" title="Unarchive">
                                Unarchived {{ selectedRows }} Record(s)
                            </button>
                        </template>
                    </div>
                </vue-good-table>   
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../../../mixins/commonMixins';
    import {HTTP} from '../../../http-common.js';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import EventBus from "../../../components/event-bus";
    Vue.component("app-footer", Footer);
    Vue.use(VueGoodTable);
    var self;
    export default {
        name: 'ListTechnicianTeamDepartmentChanges',
        components: {
        },
        mixins: [commonMixins],
        data() {
            return {
                firstLoad: 0,
                columns: [
                    {
                        label: 'Employee Number',
                        field: 'employee_number',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Employee Number", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Employee Name',
                        field: 'employee_name',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Employee Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Date',
                        field: 'date',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "DD/MM/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Employee Email',
                        field: 'employee_email',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Employee Email", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Location',
                        field: 'employee_location',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Start Date',
                        field: 'start_date',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Start Date", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Current Team/Department',
                        field: 'current_team_department',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Current Team/Department", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Team/Department Change',
                        field: 'team_department_change',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Team/Department Change", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Status',
                        field: 'status',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Status", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated By',
                        field: 'updated_by',
                        filterable: true,
			            sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Updated By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated At',
                        field: 'updated_at',
                        filterable: true,
			            sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Updated At", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '108px',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                    perPageDropdown : [],
                },
                displayPageTask: 7,
                jumpToPageTask: 0,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
                isExportTechTeamDepartmentChange: false,
                isArchivedList: 0,
                listName: 'Archived List',
                loginUserRoleId: 1,
            }
        },
        watch: {
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self.menuActive("TechnicianTeamDepartmentChangesForm");
            self.jumpToPageTask = self.serverParams.page;
            self.pageCompareTask = Math.ceil(self.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPageTask(self.jumpToPageTask)
                }
            });

            self.serverParams.perPageDropdown.push(25);
            self.serverParams.perPageDropdown.push(50);
            self.serverParams.perPageDropdown.push(100);
            self.serverParams.perPageDropdown.push(200);
            self.serverParams.perPageDropdown.push(500);
            self.loadTechTeamDepartmentChange();
        },
        methods: {
            jumpToPageInTask: function (e) {
                self.jumpToInputPageTask(self.jumpToPageTask);
            },
            changedValueTaskCustomPerPageTask: function () {
                self.jumpToInputPageTask(self.serverParams.page);
                self.loadTechTeamDepartmentChange();
            },
            changedValueTask: function (value) {
                /*console.log(value);*/
            },
            pageNumberListTask: function () {
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            jumpToInputPageTask: function (pageNumber) {
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListTask()) {
                    pageNumber = self.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function (pageNumber) {
                self.serverParams.page = pageNumber;
                self.jumpToPageTask = pageNumber;
                self.loadTechTeamDepartmentChange();
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadTechTeamDepartmentChange();
            },
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadTechTeamDepartmentChange();
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('employee_number');
                    field: ('employee_name');
                    field: ('date');
                    field: ('employee_email');
                    field: ('employee_location');
                    field: ('current_team_department');
                    field: ('team_department_change');
                    field: ('start_date');
                    field: ('status');
                    field: ('updated_by');
                    field: ('updated_at');
                };
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.id || filters.employee_number || filters.employee_name || filters.employee_email 
                    || filters.employee_location || filters.current_team_department || filters.team_department_change 
                    || filters.start_date || filters.updated_by || filters.date || filters.updated_at || filters.status
                ) {
                    self.loadTechTeamDepartmentChange();
                }
            },
            selectionChanged() {
                self.selectedRows = (self.$refs['TechTeamDepartmentChangeList'].selectedRows).length;
                /* console.log(self.selectedRows); */
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadTechTeamDepartmentChange();
            },
            archivedUnArchivedRequest: function(id, state, flag) {
                let idArray = [];
                id = (id === null || typeof (id) === "undefined" || id == '' || id == 0) ? 0 : id;
                if(id != 0) {
                    idArray.push(id);
                } else {
                    var listArr = [];
                    var selectedRequest = this.$refs["TechTeamDepartmentChangeList"].selectedRows;
                    for (var i = 0; i < selectedRequest.length; i++) {
                        listArr.push(this.$refs["TechTeamDepartmentChangeList"].selectedRows[i].id);
                    }
                    idArray = listArr;
                }
                self.$swal({
                    title: '',
                    text: 'Are you sure that you want to ' + flag + ' this Technician Team/Department Change!',
                    type: 'info',
                    confirmButtonText: 'OK',
                    showCancelButton: true,
                    // showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                        };
                        var fields = {
                            idArray: idArray,
                            state: state,
                            flag: flag,
                        };
                        HTTP.post("/techteamdepartmentchange/archive/unarchive", fields, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    self.loadTechTeamDepartmentChange();
                                }
                            })
                            .catch(function (error) {
                                self.catchHandler(err, function () {});
                            });
                    }
                });
            },
            loadArchivedRequestList: function() {
                self.isArchivedList = self.isArchivedList ? 0 : 1;
                self.listName = (self.isArchivedList) ? 'Unarchived List' : 'Archived List';
                self.loadTechTeamDepartmentChange();
            },
            loadTechTeamDepartmentChange() {
                self.firstLoad = 1;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    is_export: self.isExportTechTeamDepartmentChange,
                    is_archived_list: self.isArchivedList,
                };
                self.showLoader();
                HTTP.post("/techteamdepartmentchange/list", fields, config)
                    .then(function (response) {
                        $('#exportAllTechTimeId').prop("disabled", false);
                        self.isExportTechTeamDepartmentChange = false;
                        if (response.data.code == '200') {
                            if (response.data.message == 'success export') {
                                self.downloadFile(response.data.content.web);
                                // location.href = response.data.content.web;
                                self.loadTechTeamDepartmentChange();
                            } else {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                                self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                            }
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        $('#exportAllTechTimeId').prop("disabled", false);
                        self.isExportTechTeamDepartmentChange = false;
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            },
            exportTechTeamDepartmentChangeFunction: function(allTechTeamDepartmentChangeExport) {
                if(allTechTeamDepartmentChangeExport) {
                    self.isExportTechTeamDepartmentChange = true;
                    if (self.isExportTechTeamDepartmentChange == true) {
                        $('#exportAllTechTimeId').prop("disabled", true);
                        self.loadTechTeamDepartmentChange();
                    }
                } else {
                    var techTeamDepartmentChangeArr = [];
                    var selectedUser = this.$refs["TechTeamDepartmentChangeList"].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        techTeamDepartmentChangeArr.push(this.$refs["TechTeamDepartmentChangeList"].selectedRows[i].id);
                    }
                    $('#exportTechTeamDepartmentChangeId').prop("disabled", true);
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    };
                    var fields = {
                        tech_time_id_arr: techTeamDepartmentChangeArr
                    };
                    self.showLoader();
                    HTTP.post("/techteamdepartmentchange/export", fields, config)
                        .then(function (response) {
                            $('#exportTechTeamDepartmentChangeId').prop("disabled", false);
                            if (response.data.code == '200') {
                                self.downloadFile(response.data.content.web);
                                // location.href = response.data.content.web;
                                self.loadTechTeamDepartmentChange();
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            $('#exportTechTeamDepartmentChangeId').prop("disabled", false);
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
                }
            },
        },
    };
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Forms/TechicianTeamDepartmentChangeMaster/ListTechnicianTeamDepartmentChanges.vue